import { Heart, AirplaneTilt } from '@phosphor-icons/react';

export default function SaveTheDatePrintPage() {
  return (
    <div className="min-h-screen bg-stone-100 flex flex-col items-center justify-center p-8 print:p-0 print:bg-white">
      {/* Print Instructions */}
      <div className="mb-8 text-center print:hidden">
        <h1 className="font-display text-2xl text-stone-800 mb-2">Printable Postcard</h1>
        <p className="font-body text-sm text-stone-500">
          Print on cardstock, then fold or cut to create front and back
        </p>
      </div>

      {/* Postcard Front */}
      <div 
        className="bg-white mb-8 print:mb-0"
        style={{ 
          width: '600px',
          height: '400px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        }}
      >
        <div className="relative w-full h-full overflow-hidden">
          {/* Main Image */}
          <img
            src="https://customer-assets.emergentagent.com/job_coatapeque-wedding/artifacts/f5y8f5ka_ChatGPT%20Image%20Jan%2020%2C%202026%2C%2012_51_33%20PM.png"
            alt="Greetings from El Salvador"
            className="w-full h-full object-cover"
          />
          
          {/* Couple Photo Overlay */}
          <div className="absolute bottom-4 left-4 w-28 h-28 rounded-full overflow-hidden border-4 border-white shadow-xl">
            <img
              src="https://customer-assets.emergentagent.com/job_coatapeque-wedding/artifacts/z82or38h_Facetune_12-11-2025-12-56-12%202.jpg"
              alt="Stefanie and Walter"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Save the Date Banner */}
          <div 
            className="absolute bottom-0 right-0 px-6 py-3"
            style={{ backgroundColor: 'rgba(201, 185, 154, 0.95)' }}
          >
            <p className="font-body text-xs tracking-[0.2em] uppercase text-white mb-1">
              Save the Date
            </p>
            <p className="font-display text-lg text-white">
              December 11, 2026
            </p>
          </div>
        </div>
      </div>

      {/* Postcard Back */}
      <div 
        className="bg-white relative print:page-break-before"
        style={{ 
          width: '600px',
          height: '400px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
          backgroundColor: '#FFFDF9'
        }}
      >
        {/* Horizontal line dividing left and right */}
        <div 
          className="absolute top-0 bottom-0 left-1/2 w-px"
          style={{ backgroundColor: '#D4CFC5' }}
        />

        {/* Left Side - Message */}
        <div className="absolute top-0 left-0 w-1/2 h-full p-6 flex flex-col">
          {/* Lines for writing */}
          <div className="flex-1 relative">
            {[...Array(8)].map((_, i) => (
              <div 
                key={i} 
                className="border-b"
                style={{ 
                  borderColor: '#E8E2D9',
                  height: '36px'
                }}
              />
            ))}
            
            {/* Message overlay */}
            <div className="absolute inset-0 flex flex-col justify-center px-2">
              <p className="font-display text-xl mb-2" style={{ color: '#4A4A4A' }}>
                Stefanie & Walter
              </p>
              <p className="font-body text-sm italic mb-4" style={{ color: '#8B8B8B' }}>
                are getting married!
              </p>
              <p className="font-body text-sm mb-1" style={{ color: '#6B6B6B' }}>
                Join us in El Salvador for our
              </p>
              <p className="font-body text-sm mb-4" style={{ color: '#6B6B6B' }}>
                destination wedding celebration
              </p>
              <div className="flex items-center gap-2">
                <Heart size={12} weight="fill" style={{ color: '#C9B99A' }} />
                <p className="font-body text-xs italic" style={{ color: '#A0A0A0' }}>
                  Formal invitation to follow
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Address Area */}
        <div className="absolute top-0 right-0 w-1/2 h-full p-6">
          {/* Stamp */}
          <div className="absolute top-4 right-4 w-20 h-24 border-2 flex flex-col items-center justify-center"
               style={{ borderColor: '#C9B99A', backgroundColor: '#FFF9F0' }}>
            <AirplaneTilt size={28} style={{ color: '#C9B99A' }} className="mb-1" />
            <p className="text-xs font-bold" style={{ color: '#C9B99A' }}>2026</p>
            <p className="text-xs" style={{ color: '#B8A88A' }}>EL SALVADOR</p>
          </div>

          {/* Postmark */}
          <div className="absolute top-8 right-28 opacity-50">
            <div className="w-14 h-14 rounded-full border-2 border-dashed flex items-center justify-center"
                 style={{ borderColor: '#8B7355' }}>
              <div className="text-center">
                <p className="text-xs font-bold" style={{ color: '#8B7355' }}>DEC</p>
                <p className="text-base font-bold leading-none" style={{ color: '#8B7355' }}>11</p>
              </div>
            </div>
          </div>

          {/* Address Lines */}
          <div className="absolute bottom-6 left-6 right-6">
            <div className="space-y-4">
              {[...Array(4)].map((_, i) => (
                <div 
                  key={i} 
                  className="border-b"
                  style={{ borderColor: '#D4CFC5' }}
                />
              ))}
            </div>
            
            {/* Venue info in address area */}
            <div className="absolute top-0 left-0">
              <p className="font-body text-sm font-medium" style={{ color: '#6B6B6B' }}>
                Cardedeu
              </p>
              <p className="font-body text-sm" style={{ color: '#8B8B8B' }}>
                Lake Coatapeque
              </p>
              <p className="font-body text-sm" style={{ color: '#8B8B8B' }}>
                El Salvador
              </p>
            </div>
          </div>
        </div>

        {/* POST CARD text */}
        <div className="absolute top-3 left-1/2 transform -translate-x-1/2">
          <p 
            className="font-body text-xs tracking-[0.3em] uppercase"
            style={{ color: '#C9B99A' }}
          >
            Post Card
          </p>
        </div>
      </div>

      {/* Print button */}
      <div className="mt-8 print:hidden">
        <button
          onClick={() => window.print()}
          className="px-8 py-3 font-body text-sm text-white transition-all"
          style={{ backgroundColor: '#C9B99A' }}
        >
          Print Postcard
        </button>
        <p className="font-body text-xs text-stone-400 mt-4 text-center">
          Recommended: Print on 6x4 cardstock
        </p>
      </div>
    </div>
  );
}
